export default __webpack_public_path__ + "80457c6bdf9f1043b3b951688538bd7e.png";